import '../../Typeahead/Typeahead.scss';
import './CompatibleDevicesInput.scss';

import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { ControllerButton } from '@travelwin/core';

const className = 'c-CompatibleDevicesInput';
const typeaheadClassName = 'c-Typeahead';

interface CompatibleDevicesInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const CompatibleDevicesInput = ({
  value,
  onChange,
  placeholder,
}: CompatibleDevicesInputProps) => {
  return (
    <div className={className}>
      <div className={`${typeaheadClassName}__input-wrapper`}>
        <div className={`${typeaheadClassName}__relative-container`}>
          <span className={`${typeaheadClassName}__search-icon`}>
            <MagnifyingGlass
              size={24}
              weight="bold"
              className={`${typeaheadClassName}__icon`}
            />
          </span>
          <input
            className={`${typeaheadClassName}__input`}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
          />
          {value && (
            <ControllerButton onClick={() => onChange('')}>
              <X
                size={24}
                weight="bold"
                className={`${typeaheadClassName}__icon`}
              />
            </ControllerButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompatibleDevicesInput;
